import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=27a316e9&"
import script from "./ContactDetails.vue?vue&type=script&lang=js&"
export * from "./ContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a316e9')) {
      api.createRecord('27a316e9', component.options)
    } else {
      api.reload('27a316e9', component.options)
    }
    module.hot.accept("./ContactDetails.vue?vue&type=template&id=27a316e9&", function () {
      api.rerender('27a316e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Stops/components/ContactDetails.vue"
export default component.exports